import React from 'react';
import {TelehealthSearchBarProps} from './types';
import {Filter} from 'presentation/components/Filter';
import {Stack} from '@mui/material';
import {useTelehealthSearchBar} from './hooks/useTelehealthSearchBar';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {translations} from 'presentation/translations-new';
import {Drawer} from 'presentation/components/Drawer';
import {TelehealthFilterByLetter} from './components/TelehealthFilterByLetter';

const {apply, nearestDates, filter} = translations['pt-br'].commons;

export function TelehealthSearchBar({
	activeStep,
	placeholder,
	searchDataTagId,
}: TelehealthSearchBarProps) {
	const {
		shouldRenderAutocomplete,
		isGettingProviderNames,
		providersNameOptions,
		handleOpenDrawer,
		showProfessionalFilters,
		currentSelectedDate,
		handleChangeDate,
		availableDates,
		shift,
		disabledSelectionDate,
		externalOpenDateModal,
		setExternalOpenDateModal,
		openDrawerState,
		handleCloseDrawer,
		handleClearShift,
		handleConfirmShift,
		PERIODS,
		showFilterByLetter,
	} = useTelehealthSearchBar({activeStep});

	return (
		<Filter.Root>
			<Stack direction={'row'} gap={1}>
				{shouldRenderAutocomplete ? (
					<Filter.SearchWithAutocomplete
						placeholder={placeholder}
						loadingList={isGettingProviderNames}
						autocompleteConfig={{
							options: providersNameOptions,
						}}
					/>
				) : (
					<Filter.Search dataTagId={searchDataTagId} placeholder={placeholder} />
				)}
			</Stack>

			{showFilterByLetter ? <TelehealthFilterByLetter /> : null}

			{showProfessionalFilters ? (
				<Stack flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
					<Filter.Date
						dataTagId={{
							openButton: AppointmentBookingEnum.CLICK_DATAS_MAIS_PROXIMAS,
						}}
						currentFirstDate={currentSelectedDate}
						selectFirstDate={handleChangeDate}
						customOpenModalButton={nearestDates}
						customLabelConfirmButton={apply}
						availableDates={availableDates}
						disableConfirmButton={disabledSelectionDate}
						externalOpen={externalOpenDateModal}
						onAbandonModal={() => setExternalOpenDateModal(false)}
					/>
					<Filter.Button onClick={handleOpenDrawer} count={shift ? 1 : undefined} />
					<Drawer.Root
						open={openDrawerState}
						onOpen={handleOpenDrawer}
						onClose={() => handleCloseDrawer(true)}
						width={'420px'}
						sx={{zIndex: 9000}}>
						<Drawer.Header title={filter} onClose={() => handleCloseDrawer(true)} />
						<Drawer.ContentListByCategory categoryList={[PERIODS]} />
						<Drawer.Footer
							firstButtonOnClick={handleClearShift}
							secondButtonOnClick={handleConfirmShift}
						/>
					</Drawer.Root>
				</Stack>
			) : null}
		</Filter.Root>
	);
}
